import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import AnnouncementBar from '../components/layout/AnnouncementBar';
import Footer from '../components/layout/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1a1a1a] via-[#2d1f3d] to-[#1a1a1a]">
      <AnnouncementBar />
      <Header />
      
      <main>
        {/* Section 1 - Stream Music - Keep mobile at 60vh, desktop full height */}
        <section className="relative h-[60vh] md:h-screen flex items-center justify-center overflow-hidden bg-black pt-0">
          {/* Background Video/Image - show more of video on desktop */}
          <div className="absolute inset-0 top-0">
            <video
              src="https://customer-assets.emergentagent.com/job_yungworld-store/artifacts/38qw0rvi_TikTok_by__itsyungdexy04_0.mp4"
              autoPlay
              loop
              muted
              playsInline
              webkit-playsinline="true"
              className="w-full h-full object-cover md:object-[center_top]"
              style={{ objectPosition: 'center 60%' }}
            />
            <div className="absolute inset-0 bg-black/50" />
          </div>
          
          {/* Content */}
          <div className="relative z-10 text-center px-4">
            <p className="text-white/60 text-xs md:text-sm tracking-[0.3em] mb-2 md:mb-4 uppercase">
              Stream Yung Dexy's Latest
            </p>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-4 md:mb-8 tracking-tight">
              WORRIES & CHERRIES
            </h1>
            <Link
              to="/music"
              className="inline-block bg-white text-black px-8 md:px-10 py-3 md:py-4 text-sm font-bold tracking-wider hover:bg-gray-200 transition-all"
            >
              LISTEN NOW
            </Link>
          </div>
        </section>

        {/* Separator 1 - Decorative divider */}
        <div className="relative py-4 md:py-6 bg-gradient-to-b from-black/80 to-black/80">
          <div className="flex items-center justify-center gap-4">
            <div className="h-[1px] w-16 md:w-32 bg-gradient-to-r from-transparent to-white/50" />
            <div className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 rotate-45 bg-white/60" />
              <div className="w-2 h-2 rotate-45 border border-white/60" />
              <svg className="w-6 h-6 md:w-8 md:h-8 text-white/70" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
              </svg>
              <div className="w-2 h-2 rotate-45 border border-white/60" />
              <div className="w-1.5 h-1.5 rotate-45 bg-white/60" />
            </div>
            <div className="h-[1px] w-16 md:w-32 bg-gradient-to-l from-transparent to-white/50" />
          </div>
        </div>

        {/* Section 2 - Exclusive Merch - Single Image */}
        <section className="relative h-[60vh] md:h-screen flex items-center justify-center overflow-hidden">
          {/* Background Image - Single image only */}
          <div className="absolute inset-0">
            <img
              src="https://customer-assets.emergentagent.com/job_5b7c7715-b3c3-4548-9558-b69ad0b92b64/artifacts/779vin01_hhh.jpg"
              alt="Yung World Merch"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/40" />
          </div>
          
          {/* Content */}
          <div className="relative z-10 text-center px-4">
            <p className="text-white/60 text-xs md:text-sm tracking-[0.3em] mb-2 md:mb-4 uppercase">
              Exclusive Merch
            </p>
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-2 md:mb-4 tracking-tight">
              YUNG WORLD
            </h2>
            <p className="text-white/80 text-base md:text-lg mb-4 md:mb-8 max-w-md mx-auto">
              Premium streetwear. The World Is Mine collection.
            </p>
            <Link
              to="/shop"
              className="inline-block bg-white text-black px-8 md:px-10 py-3 md:py-4 text-sm font-bold tracking-wider hover:bg-gray-200 transition-all"
            >
              SHOP NOW
            </Link>
          </div>
        </section>

        {/* Separator 2 - Decorative divider */}
        <div className="relative py-4 md:py-6 bg-gradient-to-b from-black/80 to-black/80">
          <div className="flex items-center justify-center gap-4">
            <div className="h-[1px] w-16 md:w-32 bg-gradient-to-r from-transparent to-white/50" />
            <div className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 rotate-45 bg-white/60" />
              <div className="w-2 h-2 rotate-45 border border-white/60" />
              <svg className="w-6 h-6 md:w-8 md:h-8 text-white/70" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
              </svg>
              <div className="w-2 h-2 rotate-45 border border-white/60" />
              <div className="w-1.5 h-1.5 rotate-45 bg-white/60" />
            </div>
            <div className="h-[1px] w-16 md:w-32 bg-gradient-to-l from-transparent to-white/50" />
          </div>
        </div>

        {/* Section 3 - Music Videos */}
        <section className="relative h-[60vh] md:h-screen flex items-center justify-center overflow-hidden">
          {/* Background */}
          <div className="absolute inset-0">
            <img
              src="https://customer-assets.emergentagent.com/job_5b7c7715-b3c3-4548-9558-b69ad0b92b64/artifacts/w1im57ve_Screenshot%202026-02-02%20at%2011.19.29%E2%80%AFPM.png"
              alt="Blow My Mind - YUNGDEXY x SKILLO J"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#8B1A1A]/60 to-black/80" />
          </div>
          
          {/* Content */}
          <div className="relative z-10 text-center px-4">
            <p className="text-white/60 text-xs md:text-sm tracking-[0.3em] mb-2 md:mb-4 uppercase">
              See My World
            </p>
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-4 md:mb-8 tracking-tight">
              MUSIC VIDEOS
            </h2>
            <a
              href="https://youtube.com/@itsyungdexy"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-white text-black px-8 md:px-10 py-3 md:py-4 text-sm font-bold tracking-wider hover:bg-gray-200 transition-all"
            >
              WATCH NOW
            </a>
          </div>
        </section>

        {/* Separator 3 - Decorative divider */}
        <div className="relative py-4 md:py-6 bg-gradient-to-b from-black/80 to-[#1a1a1a]">
          <div className="flex items-center justify-center gap-4">
            <div className="h-[1px] w-16 md:w-32 bg-gradient-to-r from-transparent to-white/50" />
            <div className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 rotate-45 bg-white/60" />
              <div className="w-2 h-2 rotate-45 border border-white/60" />
              <svg className="w-6 h-6 md:w-8 md:h-8 text-white/70" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
              </svg>
              <div className="w-2 h-2 rotate-45 border border-white/60" />
              <div className="w-1.5 h-1.5 rotate-45 bg-white/60" />
            </div>
            <div className="h-[1px] w-16 md:w-32 bg-gradient-to-l from-transparent to-white/50" />
          </div>
        </div>

        {/* Section 4 - Social Links */}
        <section className="relative py-12 md:py-16 bg-[#1a1a1a]">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-8 md:mb-10">
              FOLLOW YUNG DEXY
            </h2>
            
            <div className="flex flex-wrap justify-center gap-4 md:gap-6">
              {/* Spotify */}
              <a
                href="https://open.spotify.com/artist/3z5bQVLkH6CwYqsumQO1XN"
                target="_blank"
                rel="noopener noreferrer"
                className="w-14 h-14 md:w-16 md:h-16 bg-white/10 hover:bg-[#1DB954] rounded-full flex items-center justify-center transition-all group"
              >
                <svg className="w-7 h-7 md:w-8 md:h-8 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
                </svg>
              </a>

              {/* Apple Music */}
              <a
                href="https://music.apple.com/gb/artist/yung-dexy/1714640884"
                target="_blank"
                rel="noopener noreferrer"
                className="w-14 h-14 md:w-16 md:h-16 bg-white/10 hover:bg-[#FA243C] rounded-full flex items-center justify-center transition-all group"
              >
                <svg className="w-7 h-7 md:w-8 md:h-8 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.994 6.124a9.23 9.23 0 00-.24-2.19c-.317-1.31-1.062-2.31-2.18-3.043a5.022 5.022 0 00-1.877-.726 10.496 10.496 0 00-1.564-.15c-.04-.003-.083-.01-.124-.013H5.986c-.152.01-.303.017-.455.026-.747.043-1.49.123-2.193.4-1.336.53-2.3 1.452-2.865 2.78-.192.448-.292.925-.363 1.408-.056.392-.088.785-.1 1.18 0 .032-.007.062-.01.093v12.223c.01.14.017.283.027.424.05.815.154 1.624.497 2.373.65 1.42 1.738 2.353 3.234 2.802.42.127.856.187 1.293.228.555.053 1.11.06 1.667.06h11.03c.525 0 1.048-.034 1.57-.1.823-.106 1.597-.35 2.296-.81.84-.553 1.472-1.287 1.88-2.208.186-.42.293-.87.37-1.324.113-.675.138-1.358.137-2.04-.002-3.8 0-7.595-.003-11.393zm-6.423 3.99v5.712c0 .417-.058.827-.244 1.206-.29.59-.76.962-1.388 1.14-.35.1-.706.157-1.07.173-.95.042-1.785-.455-2.105-1.392-.243-.711-.158-1.39.285-2.016.46-.648 1.13-.98 1.92-1.07.368-.04.74-.058 1.1-.13.257-.05.51-.12.728-.28.196-.145.306-.34.325-.584.01-.12.008-.24.008-.36V7.37c0-.096-.006-.193-.02-.288-.046-.292-.238-.46-.52-.47-.123-.004-.247 0-.37.015-.376.044-.75.102-1.125.153-1.175.16-2.35.32-3.526.48-.673.09-1.345.18-2.017.273-.192.026-.382.068-.56.154-.28.135-.404.372-.416.676-.004.1 0 .2 0 .3v7.7c0 .418-.057.83-.242 1.21-.29.593-.76.97-1.392 1.148-.348.1-.702.156-1.063.172-.96.037-1.8-.472-2.108-1.42-.23-.706-.14-1.378.303-1.998.46-.646 1.128-.977 1.916-1.065.375-.04.753-.058 1.12-.133.258-.053.512-.122.73-.286.2-.15.308-.353.32-.598.003-.065.002-.132.002-.198V5.58c0-.156.018-.31.05-.463.094-.44.39-.716.826-.803.263-.053.532-.082.8-.112l3.446-.468c1.14-.155 2.28-.31 3.42-.466.378-.052.755-.108 1.134-.153.197-.024.397-.03.595-.017.317.02.548.2.64.505.046.154.064.315.064.478v4.636z"/>
                </svg>
              </a>

              {/* YouTube */}
              <a
                href="https://youtube.com/@itsyungdexy"
                target="_blank"
                rel="noopener noreferrer"
                className="w-14 h-14 md:w-16 md:h-16 bg-white/10 hover:bg-[#FF0000] rounded-full flex items-center justify-center transition-all group"
              >
                <svg className="w-7 h-7 md:w-8 md:h-8 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>

              {/* TikTok */}
              <a
                href="https://www.tiktok.com/@itsyungdexy04"
                target="_blank"
                rel="noopener noreferrer"
                className="w-14 h-14 md:w-16 md:h-16 bg-white/10 hover:bg-white rounded-full flex items-center justify-center transition-all group"
              >
                <svg className="w-7 h-7 md:w-8 md:h-8 text-white group-hover:text-black transition-colors" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>

              {/* Instagram */}
              <a
                href="https://www.instagram.com/itsyungdexy/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-14 h-14 md:w-16 md:h-16 bg-white/10 hover:bg-gradient-to-br hover:from-[#833AB4] hover:via-[#FD1D1D] hover:to-[#F77737] rounded-full flex items-center justify-center transition-all group"
              >
                <svg className="w-7 h-7 md:w-8 md:h-8 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>

              {/* Bandcamp */}
              <a
                href="https://yungdexy.bandcamp.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-14 h-14 md:w-16 md:h-16 bg-white/10 hover:bg-[#1DA0C3] rounded-full flex items-center justify-center transition-all group"
              >
                <svg className="w-7 h-7 md:w-8 md:h-8 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M0 18.75l7.437-13.5H24l-7.438 13.5H0z"/>
                </svg>
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;
